module.exports = __webpack_public_path__ + "static/media/BenchSentry_logo_whiteonblue_rgb.0e60a764.svg";